"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sleep = void 0;

//
//  toolkit/async.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 8/7/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//
var sleep = function sleep(interval) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(true);
    }, interval);
  });
};

exports.sleep = sleep;